import React from 'react';
import PropTypes from 'prop-types';
import RefreshControls from '../../webcommon/common/refreshcontrols/RefreshControls';
import classnames from 'classnames';
import { noop } from 'lodash';
import defaultStyles from './GridHeader.module.scss';

const GridHeader = props => (
    <div className={ props.styles.gridHeader }>
        <div className={ classnames({
            [props.styles.redTitle]: props.changesInTradeSelection,
            [props.styles.title]: !props.changesInTradeSelection
        }) }
        >
            {props.title}
        </div>

        {props.refreshControlsActive
            ? (
                <RefreshControls
                    onClick={ props.refreshData }
                    timeLastUpdated={ props.lastUpdated }
                />
            )
            : null }
        <div className={ props.styles.spacer } />
        <div className={ props.styles.actionGroup }>

            {props.children}
        </div>
    </div>
);

GridHeader.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.shape({}),
        PropTypes.bool,
        PropTypes.node
    ]).isRequired,
    lastUpdated: PropTypes.number,
    changesInTradeSelection: PropTypes.bool,
    refreshControlsActive: PropTypes.bool,
    refreshData: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    title: PropTypes.string
};

GridHeader.defaultProps = {
    lastUpdated: Date.now(),
    changesInTradeSelection: false,
    refreshControlsActive: false,
    refreshData: noop,
    styles: defaultStyles,
    title: ''
};

export { defaultStyles };
export default GridHeader;
